import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  PagedResultDto,
  Payment,
  PaymentSearchDto
} from '@umss/shared/data-access';
import { HttpHelper } from '@umss/shared/utils';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PaymentService {
  private readonly baseUrl = 'api/Contractors/payments';

  private readonly http = inject(HttpClient);

  getAll(
    payload?: Partial<PaymentSearchDto>
  ): Observable<PagedResultDto<Payment>> {
    const params = HttpHelper.toHttpParams(payload ?? {});

    return this.http.get<PagedResultDto<Payment>>(this.baseUrl, { params });
  }
}
